/**
 * Trending view tracker (Royalcraft)
 * ------------------------------------------------------------
 * Include this on product pages only. Fires ONE ping per product
 * per browser session (30-minute cooldown) so repeat page loads /
 * refreshes from the same visitor don't inflate the count.
 *
 * Loads via: {{ 'trending-pixel.js' | asset_url | script_tag }}
 * or a plain <script src="{{ 'trending-pixel.js' | asset_url }}" defer></script>
 * placed only inside templates/product.liquid (or product.json sections).
 */
(function () {
  "use strict";

  // Shopify exposes the current product on ShopifyAnalytics.meta.product
  // on Online Store 2.0 themes. Fall back to a data attribute if you'd
  // rather set window.__trendingProductId manually in the theme.
  var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
  var product = meta && meta.product;
  var productId = (product && product.id) || window.__trendingProductId;

  if (!productId) return;

  var COOLDOWN_MS = 30 * 60 * 1000; // 30 minutes
  var storageKey = "rc_trend_view_" + productId;

  try {
    var last = sessionStorage.getItem(storageKey);
    var now = Date.now();
    if (last && now - parseInt(last, 10) < COOLDOWN_MS) {
      return; // already counted this product recently in this session
    }
    sessionStorage.setItem(storageKey, String(now));
  } catch (e) {
    // sessionStorage unavailable (private mode etc.) — fall through and
    // still send the ping rather than silently losing the view entirely.
  }

  // Deployed Worker (royalcraft-trending). Swap for a custom route like
  // trending.royalcraft.co.uk/track later if you want, see DEPLOYMENT.md.
  var ENDPOINT = "https://royalcraft-trending.damien-blackford.workers.dev/track";

  var payload = JSON.stringify({
    productId: String(productId),
    ts: Date.now(),
    path: window.location.pathname
  });

  if (navigator.sendBeacon) {
    // Use a CORS-"simple" content type (text/plain) so the beacon never
    // triggers a preflight OPTIONS round-trip — some browsers/extensions
    // silently drop beacons that require preflight. The Worker parses the
    // body as JSON regardless of the declared content type.
    var blob = new Blob([payload], { type: "text/plain;charset=UTF-8" });
    navigator.sendBeacon(ENDPOINT, blob);
  } else {
    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: payload,
      keepalive: true
    }).catch(function () {
      /* swallow network errors — this must never block the page */
    });
  }
})();
